import { render, staticRenderFns } from "./DeviceKpiContextMenu.vue?vue&type=template&id=d1c39452&scoped=true&"
import script from "./DeviceKpiContextMenu.vue?vue&type=script&lang=js&"
export * from "./DeviceKpiContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./DeviceKpiContextMenu.vue?vue&type=style&index=0&id=d1c39452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c39452",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/DeviceTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fviews%2Fapps%2Fcbs%2Fdevice%2FDeviceKpiContextMenu.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports